import React, { useEffect, useMemo, useState } from "react";
import { Source, Layer, Marker } from "react-map-gl/mapbox";
import arrowHeading from "../assets/arrowHeading.svg";

const GpsPositionTrackUnix = ({
  coordinates,
  color,
  width = 4,
  equipmentName,
  showMarker,
  actualTimeUnix,
}) => {
  const firstPoint = 0;
  const id_source = "track-line-source" + color;

  const getLastPointByTime = (points, time) => {
    let last = null;
    for (let i = 0; i < points.length; i++) {
      if (points[i].timestampUnix <= time) last = points[i];
      else break;
    }
    return last;
  };

  const currentPoint = useMemo(() => {
    return getLastPointByTime(coordinates, actualTimeUnix);
  }, [coordinates, actualTimeUnix]);

  const lineGeoJson = {
    type: "Feature",
    geometry: {
      type: "LineString",
      coordinates: coordinates.map((coord) => [
        coord.coor.longitude,
        coord.coor.latitude,
      ]),
    },
  };

  const lineLayer = {
    id: "track-line" + color,
    type: "line",
    paint: {
      "line-color": color,
      "line-width": width,
    },
  };

  return (
    <>
      <Source id={id_source} type="geojson" data={lineGeoJson}>
        <Layer {...lineLayer} />
      </Source>

      {currentPoint && showMarker && (
        <Marker
          longitude={currentPoint.coor.longitude}
          latitude={currentPoint.coor.latitude}
          anchor="center"
        >
          <div className="relative flex flex-col items-center">
            

            <div
              className="w-5 h-5 rounded-full border-2 border-white shadow-lg"
              style={{ backgroundColor: color }}
            />

            <div className="mt-1 px-1 bg-black text-white rounded shadow text-xs whitespace-nowrap">
              {equipmentName}
            </div>
          </div>
        </Marker>
      )}
    </>
  );
};

export default GpsPositionTrackUnix;
